import BriefingTable from "components/Briefing/subcomponents/table";
import { useEffect, useState } from "react";

import Actions from "components/Briefing/subcomponents/actions"; // Fixed typo (Actoins -> Actions)
import { useSelector } from "react-redux";
import { corssBorderMiscNotesAPI } from "components/Apis/Briefing";
import { getFieldShiftFlag } from "components/Briefing/helpers";
import HistoryViewer from "components/Briefing/subcomponents/safety-subcomponents/historyViewer";
import { TextField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import { fetchBriefingDocument } from "components/Briefing/helpers";
import toast from "react-hot-toast";

const MiscNotesTable = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const briefing = useSelector((state) => state.briefing.line);
    const shift = useSelector((state) => state.shift);

    const archived = (briefing === "Old Briefings");

    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    function backendSync(id, changes) {
        return corssBorderMiscNotesAPI.update(id, { ...changes, shift_flag: getFieldShiftFlag(shift) })
            .then(() => {
                setRefresh(!refresh);
            })
    }

    const handleFileUploadClick = (rowID) => {
        document.getElementById(`document-uploader-${rowID}`).click();
    }

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            if (archived) {
                const requestPayload = {
                    "startDate": startDate,
                    "endDate": endDate,
                    "searchTerm": searchTerm
                }
                const response = await corssBorderMiscNotesAPI.getArchive(requestPayload); // Changed to truck API
                setData(response.data);
            }
            else {
                const response = await corssBorderMiscNotesAPI.filter({
                    archived: false,
                    search_term: searchTerm
                });
                setData(response.data);
            }
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing]);

    const headers = [
        "ID",
        "Pro #",
        "Notes",
        "Attachments",
        'Act.'
    ];

    const renderRow = (row) => {
        return (
            <>
                <tr key={`misc-notes-row-${row.id}`} className="safety-row">
                    <td className="row-id-cell">
                        <div className="row-id-div">
                            {row.id}
                        </div>
                    </td>
                    <td style={{ width: "15%" }}>
                        <TextField
                            row={row}
                            label={"pro"}
                            onBackendSync={backendSync}
                        />
                    </td>
                    <td>
                        <TextField
                            row={row}
                            label={"note"}
                            onBackendSync={backendSync}
                        />
                    </td>
                    <td style={{ width: "15%" }}>
                        {!row.attachments || row.attachments.length === 0 ? (
                            <div className="fixed-input">No Attachments Uploaded Yet</div>
                        ) : (
                            row.attachments.map((attachment, index) => (
                                <a
                                    key={index}
                                    className="href"
                                    onClick={() => fetchBriefingDocument(attachment.id)}
                                    title={attachment.document_name}  // Shows full name on hover
                                >
                                    {attachment.document_name.length > 20
                                        ? attachment.document_name.slice(0, 20) + '...'
                                        : attachment.document_name}
                                </a>
                            ))
                        )}
                    </td>
                    <td className="actions-cell">
                        <Actions
                            onDelete={async () => {
                                corssBorderMiscNotesAPI.delete(row.id).then((response) => { // Changed to truck API
                                    setRefresh(!refresh);
                                }).catch((error) => {
                                    console.error("Error deleting row:", error);
                                    toast.error(error.response?.data?.msg || "An error occurred while deleting the row.");
                                });
                            }}
                            onArchive={async () => {
                                corssBorderMiscNotesAPI.archive(row.id).then(() => { // Changed to truck API
                                    setRefresh(!refresh);
                                }).catch((error) => {
                                    console.error("Error archiving row:", error);
                                });
                            }}
                            onAdd={() => handleFileUploadClick(row.id)}
                        />
                        <input
                            style={{ display: "none" }}
                            id={`document-uploader-${row.id}`}
                            type="file"
                            multiple
                            accept=".jpeg,.jpg,.pdf,.png"
                            onChange={(event) => {
                                corssBorderMiscNotesAPI.uploadAttachment(row.id, event.target.files).then(() => {
                                    setRefresh(!refresh);
                                })
                                    .catch((error) => {
                                        console.error("Error uploading document:", error);
                                    });
                            }}
                        />
                    </td>
                </tr>
                <tr className="safety-updated-at-row">
                    <td colSpan={headers.length - 1} className="pt-0 pb-0">
                        <span className="input-updated-at-label">
                            Updated by: {row.updated_by ? row.updated_by : "Unknown"} {row.updated_at ? row.updated_at : "Never"}
                        </span>
                    </td>
                </tr>
            </>
        );
    }

    return (
        <>
            <div className="table-header">
                <h2>Miscellaneous Notes</h2>
                <HistoryViewer historyAPICall={corssBorderMiscNotesAPI.getHistory} />

            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={
                    async () => {
                        await corssBorderMiscNotesAPI.create({ shift_flag: getFieldShiftFlag(shift) });
                        setRefresh(!refresh);
                    }
                }
            />
        </>
    );
};

export default MiscNotesTable;